import { Injectable } from '@angular/core';
import { isLocalHostname } from './is-local-api-regex';

@Injectable({
  providedIn: 'root',
})
export class IsLocalMatcherService {
  constructor() {}

  /** PRIVATE */
  private _isLocal?: boolean;

  private determineIfLocal(): boolean {
    const devEnvMatcher = isLocalHostname;
    return this.getHostName().search(devEnvMatcher) > -1;
  }

  private getHostName(): string {
    return location && location.hostname;
  }

  /** PUBLIC */
  public get isLocal(): boolean {
    if (this._isLocal === undefined) this._isLocal = this.determineIfLocal();
    return this._isLocal;
  }
}
